<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';

  import { createBreakpointMediaQueryStore } from '$lib/stores/media';
  import { cn } from '$lib/utils';

  import type { AssetStoryblok, ResponsiveVideoStoryblok } from '$types/bloks';

  export let block: ResponsiveVideoStoryblok;

  let className: string | undefined = undefined;
  export { className as class };
  export let videoClass: string | undefined = undefined;

  const desktop = createBreakpointMediaQueryStore('lg');
  let video: HTMLVideoElement;
  let videoAsset: AssetStoryblok | undefined = undefined;

  $: videoAsset =
    $desktop || !block.mobile_video?.filename ? block.desktop_video : block.mobile_video;
</script>

{#if videoAsset?.filename}
  {#if videoAsset.is_external_url}
    <iframe
      src={videoAsset?.filename}
      title="External Video"
      class={cn(videoClass, 'h-full w-full')}
    ></iframe>
  {:else}
    <div class={cn(className, 'h-full w-full')} use:storyblokEditable={block}>
      <video
        bind:this={video}
        autoplay
        loop
        muted
        playsinline
        src={videoAsset?.filename}
        class={cn('h-full w-full object-cover', videoClass)}
      />
    </div>
  {/if}
{/if}
